import { FooterCSSStyleImpl } from './footercss';
import { UIComponentProps, UIComponentImpl, UIComponentState, UIDataModel, UIComponentHandler } from '../uicomponent';
import { BaseContext } from '../../../utils/basecontext';
import { UIComponentView } from '../uicomponentview';
import { FooterViewImpl } from './footerview';
import { UIComponentCSSStyle } from '../uicomponentcss';

export interface FooterComponentProps extends UIComponentProps
{
    isRTL?:boolean;
}

export class FooterComponent extends UIComponentImpl<FooterComponentProps, UIComponentState, UIDataModel>
{
    constructor(props: FooterComponentProps)
    {
        super(props);
    }

    protected createComponentView(applicationContext: BaseContext, uiComponentHandler: UIComponentHandler): UIComponentView<UIDataModel>
    {
        return new FooterViewImpl(applicationContext, uiComponentHandler);
    }

    protected createComponentCSS(applicationContext: BaseContext): UIComponentCSSStyle
    {
        return new FooterCSSStyleImpl(applicationContext);
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/toolkit/footer-native/footercomponent.tsx